import ViewUserRoleDetailsContainer from "./ViewUserRoleDetailsContainer";

export default ViewUserRoleDetailsContainer;
